const colors = {
  linearBlue:
    'linear-gradient(180deg, #1f2869 0%, #355f9f 48.23%, #50a0d3 100%)',
  linearOrange: 'linear-gradient(180deg, #f2a616 0%, #fee301 100%)',
  linearWhite: 'linear-gradient(180deg, #ffffff 30%, #caddee 100%)',
  lightBlue: '#CADDEE',
  middleBlue: '#355F9F',
  darkBlue: '#1F2869',
  blue: '#50A0D3',
  orange: '#F2A616',
  yellow: '#FEE301',
}

export default colors
